import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1506adc5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "feedback-case-assignment-container"
}
const _hoisted_2 = { class: "account-row" }
const _hoisted_3 = { class: "feedback-case-assignment-content" }
const _hoisted_4 = {
  key: 0,
  class: "box-no-matches"
}

import { ref, onMounted, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import useEmitter from '@/composables/useEmitter'
import { getTeamMembers, updateCaseAssignment } from '@/api/chat'
import { showToast, hideToast } from '@/mobile/src/utils/toastbus'
import { ToastColor, ToastDuration, ToastIcon } from '@/mobile/src/types/toasts'
import { sleep } from '@/utils/async'
import ActionButton from '@/mobile/src/components/appV4/ActionButton.vue'
import LoadingCard from '@/mobile/src/components/appV4/LoadingCard.vue'
import InputSingleLine from '@/components/Rain/Inputs/InputSingleLine.vue'
import { faTriangleExclamation } from 'fontawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from 'fontawesome/vue-fontawesome'

interface UserDetails {
    id: string | number
    name: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FeedbackCaseAssignment',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const emitter = useEmitter()
const store = useStore()

const chatCustomData = computed(() => store.getters['chatCustomData'])
const chatCaseAssignment = ref<UserDetails[]>([])
const loadingCaseAssignment = ref(false)

const filterText = ref('')

const filteredChatCaseAssignment = computed(() => {
    if (!filterText.value) {
        return chatCaseAssignment.value
    }
    return chatCaseAssignment.value.filter((user) =>
        user.name.toLowerCase().includes(filterText.value.toLowerCase())
    )
})

const handleInputChanges = (value: string) => {
    filterText.value = value.toLowerCase()
}

const loadTeamMembers = async () => {
    loadingCaseAssignment.value = true
    try {
        const result = await getTeamMembers(
            Number(route.params.feedbackid ?? '')
        )
        chatCaseAssignment.value = [
            ...(chatCustomData.value.case_assigned_user_id !== null
                ? [{ id: 'unassigned', name: 'Unassigned' }]
                : []),
            ...result.data.users,
        ]
    } catch (error) {
        console.error('Failed to load team members:', error)
        showToast(
            emitter,
            ToastIcon.Alert,
            ToastColor.Warning,
            'Failed to load team members',
            ToastDuration.Standard
        )
    } finally {
        loadingCaseAssignment.value = false
    }
}

const setAssignTo = async (userId: string | number, userName: string) => {
    let responseSuccess = true
    const loadingToast = showToast(
        emitter,
        ToastIcon.Waiting,
        ToastColor.EmailReply,
        userId === 'unassigned' ? 'Unassigning case' : 'Assigning case'
    )

    try {
        await updateCaseAssignment(route.params.feedbackid ?? '', userId)
    } catch (error) {
        responseSuccess = false
        console.error('Failed to assign case:', error)
    } finally {
        hideToast(emitter, loadingToast)
    }

    if (responseSuccess) {
        showToast(
            emitter,
            ToastIcon.Success,
            ToastColor.Workflow,
            userId === 'unassigned' ? 'Case Unassigned' : 'Case Assigned',
            ToastDuration.Standard
        )

        await store.dispatch('reloadChatCustomData')
        await sleep(ToastDuration.Standard)
        router.back()
    } else {
        showToast(
            emitter,
            ToastIcon.Alert,
            ToastColor.Warning,
            'Failed to assign case',
            ToastDuration.Standard
        )
    }
}

onMounted(() => {
    loadTeamMembers()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (loadingCaseAssignment.value)
      ? (_openBlock(), _createBlock(LoadingCard, {
          key: 0,
          variant: "single",
          borderless: ""
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(InputSingleLine, {
              class: "tenant-search",
              autocomplete: "off",
              autocapitalize: "off",
              variant: "glass",
              type: "search",
              value: filterText.value,
              label: 'Enter the Team Member Name',
              spellcheck: false,
              onInput: handleInputChanges
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredChatCaseAssignment.value, (userDetails) => {
              return (_openBlock(), _createBlock(ActionButton, {
                key: userDetails.id,
                "on-click": 
                        () => setAssignTo(userDetails.id, userDetails.name)
                    ,
                label: userDetails.name
              }, null, 8, ["on-click", "label"]))
            }), 128))
          ]),
          (filterText.value && filteredChatCaseAssignment.value.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("span", null, [
                  _createVNode(_unref(FontAwesomeIcon), {
                    class: "icon-no-match",
                    icon: _unref(faTriangleExclamation)
                  }, null, 8, ["icon"]),
                  _createTextVNode(" No matches were found")
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}
}

})